(function() {
  const el = document.getElementById('bundle-contents');
  if (!el) return;

  const bundleMap = {
    'Full': [
      { qty: 1, name: 'Fitted Sheet', size: 'Full' },
      { qty: 1, name: 'Duvet Cover', size: 'Full/Queen' },
      { qty: 2, name: 'Pillowcases', size: 'Standard' }
    ],
    'Queen': [
      { qty: 1, name: 'Fitted Sheet', size: 'Queen' },
      { qty: 1, name: 'Duvet Cover', size: 'Full/Queen' },
      { qty: 2, name: 'Pillowcases', size: 'Standard' }
    ],
    'King': [
      { qty: 1, name: 'Fitted Sheet', size: 'King' },
      { qty: 1, name: 'Duvet Cover', size: 'King' },
      { qty: 2, name: 'Pillowcases', size: 'King' }
    ]
  };

  el.style.display = 'block';

  function updateBundleContents(size) {
    const list = document.getElementById('bundle-contents-list');
    const items = bundleMap[size];
    if (!items || !list) return;
    list.innerHTML = items.map(item => `
      <li class="bundle-contents__item">
        <span class="bundle-contents__qty">${item.qty}x</span>
        <span class="bundle-contents__name">${item.name}</span>
        <span class="bundle-contents__size">${item.size}</span>
      </li>
    `).join('');
  }

  function showSavingsNearPrice() {
    // Remove any previously added value label
    const existingLabel = document.getElementById('value-label');
    if (existingLabel) existingLabel.remove();

    const compareEl = document.querySelector('.compare-at-price');
    if (!compareEl) return;

    // Remove strikethrough and style it cleanly
    compareEl.style.textDecoration = 'none';
    compareEl.style.opacity = '1';
    compareEl.style.fontFamily = 'AkkuratCustom, sans-serif';
    compareEl.style.fontSize = '14px';
    compareEl.style.color = '#9aa8b0';

    // Add VALUE label
    const valueLabel = document.createElement('span');
    valueLabel.id = 'value-label';
    valueLabel.textContent = ' VALUE';
    valueLabel.style.cssText = `
      font-family: AkkuratCustom, sans-serif;
      font-size: 14px;
      color: #9aa8b0;
      letter-spacing: 0.05em;
    `;
    compareEl.appendChild(valueLabel);
  }

  function getSelectedSize() {
    const checkedRadio = document.querySelector('.variant-picker input[type="radio"]:checked');
    if (checkedRadio) return checkedRadio.value;
    const select = document.querySelector('.variant-picker select');
    if (select) return select.options[select.selectedIndex]?.text || select.value;
    return null;
  }

  function init() {
    const size = getSelectedSize();
    if (size) updateBundleContents(size);
    showSavingsNearPrice();
  }

  document.addEventListener('change', function(e) {
    if (e.target.type === 'radio' && e.target.closest('.variant-picker')) {
      updateBundleContents(e.target.value);
      setTimeout(showSavingsNearPrice, 300);
    }
  });

  document.addEventListener('variant:change', function(e) {
    if (e.detail?.variant?.title) {
      updateBundleContents(e.detail.variant.title.split(' / ')[0]);
      setTimeout(showSavingsNearPrice, 300);
    }
  });

  init();
  setTimeout(init, 500);
})();